export default "__VITE_ASSET__ClJNWmS2__"